// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import Vuetify from "vuetify";
import Clipboard from "v-clipboard";
/* import MediumEditor from 'medium-editor'; */
import App from "./App";
import * as filters from "./util/filters";
import AppState from "./util/AppState";
import bus from "./util/bus";

Vue.use(Vuetify, {
  theme: {
    primary: "#8BC34A",
    secondary: "#03A9F4",
    accent: "#FF9800",
    error: "#DA0000",
    info: "#00BCD4",
    success: "#4CAF50",
    warning: "#FFC107"
  }
});
Vue.use(Clipboard);
Vue.config.productionTip = false;

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

/* Vue.directive('wysiwyg', {
  bind(el) {
    Vue.nextTick(() => new MediumEditor(el));
  }
}); */

Vue.component("i-frame", {
  render(h) {
    return h("iframe", {
      on: { load: this.renderChildren }
    });
  },
  beforeUpdate() {
    // freezing to prevent unnessessary Reactifiation of vNodes
    this.iApp.children = Object.freeze(this.$slots.default);
  },
  methods: {
    renderChildren() {
      this.$nextTick(() => {
        const children = this.$slots.default;
        const doc = this.$el.contentDocument;
        const body = doc.body;
        const head = doc.head;
        // Add meta
        const meta = doc.createElement("meta");
        meta.httpEquiv = "X-UA-Compatible";
        meta.content = "IE=edge";
        head.appendChild(meta);
        const meta2 = doc.createElement("meta");
        meta2.charset = "utf-8";
        head.appendChild(meta2);
        this.addMeta(
          doc,
          head,
          "viewport",
          "width=device-width, initial-scale=1, shrink-to-fit=no"
        );
        // TODO: Add meta keywords, description, author etc

        // Styles for preview Editor
        this.addStyle(
          doc,
          head,
          `${AppState.baseURL}/static/templates/_preview.css`
        );
        this.addStyle(
          doc,
          head,
          "https://cdn.jsdelivr.net/npm/medium-editor@5.23.2/dist/css/medium-editor.min.css"
        );
        this.addStyle(
          doc,
          head,
          "https://cdn.jsdelivr.net/npm/medium-editor@5.23.2/dist/css/themes/flat.css"
        );

        // Styles for Theme 1
        // TODO: make google Fonts selectable at Page or Project Level
        body.className += " stretched";
        this.addStyle(
          doc,
          head,
          "https://fonts.googleapis.com/css?family=Lato:300,400,400i|Montserrat:400,700"
        );
        this.addStyle(
          doc,
          head,
          "https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css"
        );
        this.addStyle(
          doc,
          head,
          "https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css"
        );
        this.addStyle(
          doc,
          head,
          `${AppState.baseURL}/static/templates/theme1/_themify.css`
        );
        this.addStyle(
          doc,
          head,
          `${AppState.baseURL}/static/templates/theme1/_style.css`
        );
        this.addStyle(
          doc,
          head,
          `${AppState.baseURL}/static/templates/theme1/_global.css`
        );
        this.addStyle(
          doc,
          head,
          `${AppState.baseURL}/static/templates/theme1/theme/red.css`
        );
        // THEME: /theme1/theme/red.css  gold.css
        /* TODO: Favicons
        <link rel="shortcut icon" href="img/favicon.ico" type="image/x-icon">
        <link rel="apple-touch-icon" href="img/apple-touch-icon.png">
        */

        const el = doc.createElement("DIV"); // we will mount or nested app to this element
        body.appendChild(el);

        // Add Required Scripts
        this.addScriptCb(
          doc,
          body,
          "https://code.jquery.com/jquery-1.12.4.min.js", // 1.11.4 is on theme.
          () => {
            this.addScriptCb(
              doc,
              body,
              "https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js",
              () => {
                this.addScript(
                  doc,
                  body,
                  `${AppState.baseURL}/static/templates/theme1/js/global.js`
                );
                AppState.previewReady = true;
                bus.$emit("previewInit"); // , { blockID: newBlock.blockID }
              }
            );
          }
        );

        const iApp = new Vue({
          name: "iApp",
          // freezing to prevent unnessessary Reactifiation of vNodes
          data: { children: Object.freeze(children) },
          render(h) {
            return h("div", this.children);
          }
        });
        iApp.$mount(el); // mount into iframe
        this.iApp = iApp; // cache instance for later updates
      });
    },
    addStyle(doc, head, src) {
      const link = doc.createElement("link");
      link.type = "text/css";
      link.rel = "stylesheet";
      link.media = "all";
      link.href = src;
      head.appendChild(link);
    },
    addScriptCb(doc, body, src, callback) {
      const script = doc.createElement("script");
      script.type = "text/javascript";
      if (script.readyState) {
        // IE
        script.onreadystatechange = () => {
          if (
            script.readyState === "loaded" ||
            script.readyState === "complete"
          ) {
            script.onreadystatechange = null;
            callback();
          }
        };
      } else {
        // Others
        script.onload = () => {
          callback();
        };
      }
      script.src = src;
      body.appendChild(script);
    },
    addScript(doc, body, src) {
      const script = doc.createElement("script");
      script.type = "text/javascript";
      script.src = src;
      body.appendChild(script);
    },
    addMeta(doc, head, name, content) {
      const meta = doc.createElement("meta");
      meta.name = name;
      meta.content = content;
      head.appendChild(meta);
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js